export default class TextUtils {
    static camelCaseToNormal(text: string): any {
        if(text){
            let res = text;
            // insert a space before all caps
            res = res.replace(/([A-Z])/g, ' $1').trim();
            // uppercase the first character
            res = res.replace(/^./, function(str){ return str.toUpperCase(); })
            return res;
        } else return '';
    }

    static currencyFormatter(value: number, locale: string = "en-US", currency: string = "USD"): string {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency,
        }).format(value);
    }

    /**
     * Formats a fax number by automatically prepending "+1" for US/Canada numbers.
     * Preserves international numbers unchanged.
     *
     * @param input - The fax number input from the user
     * @returns Formatted fax number
     *
     * Examples:
     * - "5551234567" → "+15551234567"
     * - "15551234567" → "+15551234567"
     * - "+15551234567" → "+15551234567"
     * - "+44 20 1234 5678" → "+442012345678" (international, unchanged)
     */
    static formatFaxNumber(input: string): string {
        if (!input) {
            return input;
        }

        const hasPlus = input.startsWith('+');

        // Remove ALL non-digit characters (including all plus signs)
        const digitsOnly = input.replace(/\D/g, '');

        // Only format US/Canada numbers (10 digits or 11 digits starting with 1)
        if (digitsOnly.length === 10) {
            // 10 digits → add +1
            return '+1' + digitsOnly;
        } else if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
            // 11 digits starting with 1 → add +
            return '+' + digitsOnly;
        }

        // For other cases (international, invalid), preserve original plus if present
        return hasPlus ? '+' + digitsOnly : (digitsOnly || input);
    }
}
